import { Subject } from './subject.js';

const createState = (target, { skipUnchanged = true } = {}) => {
  const subject = new Subject();
  const proxy = new Proxy(target, {
    // eslint-disable-next-line sonarjs/no-invariant-returns -- this only complicates code
    set(proxyTarget, key, val) {
      const oldValue = proxyTarget[key];
      if (skipUnchanged && oldValue === val) return true;
      proxyTarget[key] = val;
      subject.fire({
        type: oldValue === void 0 ? "add" : "change",
        object: target,
        name: key,
        oldValue
      });
      return true;
    }
  });
  return [proxy, subject];
};

export { createState };
